import {
  SET_AQL_LIMIT_MAJOR,
  SET_AQL_LIMIT_MINOR,
  SET_INSPECTION_LEVEL,
  SET_MIN_ORDER_QTY,
} from '../types';

export const setAqlLimitMajor = (aqlLimitMajor) => ({
  type: SET_AQL_LIMIT_MAJOR,
  aqlLimitMajor,
});

export const setAqlLimitMinor = (aqlLimitMinor) => ({
  type: SET_AQL_LIMIT_MINOR,
  aqlLimitMinor,
});

export const setInspectionLevel = (inspectionLevel) => ({
  type: SET_INSPECTION_LEVEL,
  inspectionLevel,
});

export const setMinOrderQty = (minOrderQty) => ({
  type: SET_MIN_ORDER_QTY,
  minOrderQty,
});
